import { Button } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { isClapAdminORClapManager } from "../../utils/clapUtils";

const CatalogHeader = ({
  title,
  handleClick,
}: {
  title: string;
  handleClick: Function;
}) => {
  const { userDetails } = useSelector((state: RootState) => state.user);

  const onClick = () => {
    handleClick();
  };

  return (
    <div className="flex justify-between items-center">
      <div className="text-heading20">{title}</div>
      {isClapAdminORClapManager(userDetails) && (
        <div>
          <Button type="primary" onClick={onClick}>
            Create {title.slice(0, title.length - 1)}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CatalogHeader;
